module.exports = __webpack_public_path__ + "static/MRI-image-f9e90e416d1be09f5b225d1e3480f724.jpeg";